// extracted by css-extract-rspack-plugin
export default {"cls1":"common-cls1_69R","cls2":"common-cls2_kxr common-cls1_69R"};